import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SapInventoryService {

  getSapInventoryDataUrl = 'SAPInventoryUpload/GetPurchaseSAPUploadData';
  sapInventoryData = "Warehouse/SAP/GetSAPInventory";


  constructor(private http: HttpClient) { }

  getSAPInventoryData(purchaseDate: Date){
    return this.http.post<any>(environment.baseUrl + this.getSapInventoryDataUrl, {
        purchaseDate : new Date(purchaseDate).toLocaleDateString("fr-CA",{year:"numeric", month:"2-digit", day:"2-digit"})
    });
  }

  getSAPInventoryDataWarehouse(params: any){
    return this.http.get<any>(environment.baseUrl + this.sapInventoryData, {params});
  }

  SendInventoryDataToSAP(params: any){
    return this.http.post<any>(environment.baseUrl + 'Warehouse/SAP/SendDataToSAP',{}, {params});
  }


  SendDataToSAPInvoice(data: any){
    return this.http.post<any>(environment.baseUrl + 'SAPInvoiceUpload/SendDataToSAP',data );
  }


  getSAPTSADispatchData(params: any){
    return this.http.get<any>(environment.baseUrl + 'Warehouse/SAP/GetSAPTSADispatchData', {params});
  }

  sendDataToSAPTSADispatchData(params: any){
    return this.http.get<any>(environment.baseUrl + 'Warehouse/SAP/SendDataToSAPTSADispatchData', {params});
  }


  getSAPTSAReceiveData(params: any){
    return this.http.get<any>(environment.baseUrl + 'Warehouse/SAP/GetSAPTSAReceiveData', {params});
  }


  sendDataToSAPTSAReceiveData(params: any){
    return this.http.get<any>(environment.baseUrl + 'Warehouse/SAP/SendDataToSAPTSAReceiveData', {params});
  }


  getDistinctTSADispatchNumbers(params: any){
    return this.http.get<any>(environment.baseUrl + 'Warehouse/SAP/GetDistinctTSADispatchNumbers', {params});
  }

  getWarehouses(){
    return this.http.get<any>(environment.baseUrl + 'Location/GetWarehouses');
  }

  getDispatchDatesByYear(params: any) {
    return this.http.get<any>(environment.baseUrl + 'Reports/Filter/GetDisptachDatesByYear', { params });
  }

  getReceiveDatesByYear(params: any) {
    return this.http.get<any>(environment.baseUrl + 'Reports/Filter/GetRecieveDatesByYear', { params });
  }



}
